<div class="container">
    <mat-card class="m20 ">
        <h2 class="main-content">Sign up for my business on VISITMAKER</h2>
        <mat-card-actions>
            <button class="select-button" mat-raised-button color="primary" (click)="newBusinessClick()">Select</button>
        </mat-card-actions>
    </mat-card>
    
    <mat-card class="m20">
        <h2 class="main-content">Add me to a business (My business owner covers my license)</h2>
        <mat-card-actions>
            <button class="select-button" mat-raised-button color="primary" (click)="businessClick()">Select</button>
        </mat-card-actions>
    </mat-card>
</div>